import React, { Component } from 'react';
import { DatePicker, Form, Input, message, Modal, Row, Select } from 'antd';
import { connect } from 'react-redux';

import { querySaveContract } from '@api/xxcrm/contract';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contract_type: this.props.contract_type,
    };
  }

  componentDidMount() {}

  submit = () => {
    const data = this.props.form.getFieldsValue();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        querySaveContract(data).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.props.loadDate();
            this.props.cancel();
          } else {
            message.error(res.message);
          }
        });
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { contract_type: contractType } = this.state;
    return (
      <Modal
        title="添加合同"
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem label="合同编号" {...formItemLayout}>
              {getFieldDecorator('no', {
                rules: [
                  {
                    required: true,
                    message: '合同编号不符合规则！',
                    pattern: /(^LXCRM\d+$)|(^DSYDH\d+$)|([1-9]{2})(((0[13578]|1[02])(0[1-9]|[12]\d|3[01]))|((0[469]|11)(0[1-9]|[12]\d|30))|(02(0[1-9]|1\d|2\d)))\d{2,3}$/,
                  },
                ],
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="合同类型" {...formItemLayout}>
              {getFieldDecorator('type', {
                rules: [{ required: true, message: '合同类型不能为空！' }],
              })(
                <Select>
                  {contractType.map((item, index) => {
                    return <Option key={item.value}>{item.key}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="过期时间" {...formItemLayout}>
              {getFieldDecorator('maturityDate', {
                rules: [{ required: true, message: '过期时间不能为空！' }],
              })(<DatePicker style={{ width: '100%' }} />)}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalAdd.js